import { css } from '@/styled-system/css';

export const progressStepperStepMetaTextStyles = css.raw({
  color: 'ProgressMeter.Label.metaText',
  textStyle: 'body-sm',
});
